// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"887ccc8f","186":"512f43d0","272":"cdb600e5","372":"0489f9bc","443":"8565c9fe","684":"b05d61d9","738":"c7f263ce","787":"cda612ba","841":"745edbb9","851":"67a10c16","856":"9048f667"}[chunkId] + ".chunk.js";
};